import ClientTokenWeb from "../../../../content/sdk/web/2.x.x/_common/clientToken.mdx";
import ErrorCode from "../../../../content/sdk/web/2.x.x/primer/_showVaultManager/errorCode.mdx";
import PaymentMethodType from "../../../../content/sdk/web/2.x.x/primer/_showVaultManager/paymentMethodType.mdx";
import CustomizationStyle from "../../../../content/sdk/web/2.x.x/_common/customizationStyle.mdx";
import Form from "../../../../content/sdk/web/2.x.x/_common/form.mdx";
import SubmitButton from "../../../../content/sdk/web/2.x.x/_common/submitButton.mdx";
import ProcessingIndicator from "../../../../content/sdk/web/2.x.x/_common/processingIndicator.mdx";
import ErrorMessage from "../../../../content/sdk/web/2.x.x/_common/errorMessage.mdx";
import VaultManagerPaymentMethodsOptions from "../../../../content/sdk/web/2.x.x/primer/_showVaultManager/paymentMethodsOptions.mdx";
import ApiVersion from "../../../../content/sdk/web/2.x.x/_common/apiVersion.mdx";
import * as React from 'react';
export default {
  ClientTokenWeb,
  ErrorCode,
  PaymentMethodType,
  CustomizationStyle,
  Form,
  SubmitButton,
  ProcessingIndicator,
  ErrorMessage,
  VaultManagerPaymentMethodsOptions,
  ApiVersion,
  React
};